<template>
    <LoginContainer :buttons="button" :errorMessage="errorMessage" :goToRoutes="goToRoute" :logo="logo"
        @submit="ResetPass" :title="$t('resetPassword')">
        <template #form v-if="!hasReset">
            <InputContent name="newPassword" :label="`Nova ${$t('password')}`" placeholder="Password" v-model="password"
                type="password" />
            <InputContent name="confirmNewPassword" :label="`Confirmar nova ${$t('password')}`" placeholder="Password"
                v-model="confirmPassword" type="password" />
        </template>
        <template #form v-else>
            Password has been reset
        </template>
    </LoginContainer>
</template>

<script>
import LoginContainer from '@/components/login/Login.vue';
import InputContent from '@/components/inputs/Content.vue';
import devLogo from "../assets/logos/dev-logo.png"
import { app } from "../firebaseApp";
import { getAuth, confirmPasswordReset } from 'firebase/auth';

const auth = getAuth(app);

export default {
    name:'LoginResetPassPage',
    props: {
        code: {
            required: true,
        }
    },
    components: {
        LoginContainer,
        InputContent,
    },
    data() {
        return {
            password: '',
            confirmPassword: '',
            errorMessage: '',
            goToRoute: [],
            hasReset: false,
        }
    },
    methods: {
        async ResetPass() {
            this.errorMessage = ""
            if (this.hasReset) {
                this.$router.push({ name: 'Home' });
            }
            if (this.password != this.confirmPassword) {
                this.errorMessage = `As ${this.$t('password', 0)} não coincidem`
                return
            }
            try {
                await confirmPasswordReset(auth, this.code, this.password)
                this.hasReset = true
            }
            catch (error) {
                console.log(error)
                this.errorMessage = error.code
                switch (this.errorMessage) {
                    case 'auth/internal-error':
                        this.errorMessage = 'Código inválido. Adquira um novo'
                        break
                    case 'auth/weak-password':
                        this.errorMessage = `${this.$t('password')} de acesso demasiado fraca`
                        break
                    case 'auth/wrong-password':
                        this.errorMessage = `${this.$t('password')} de acesso incorrecta`
                        break
                    case 'auth/invalid-action-code':
                        this.errorMessage = 'Código inválido. Adquira um novo'
                        break
                    case 'auth/expired-action-code':
                        this.errorMessage = 'Código expirado. Adquira um novo'
                        break
                    default:
                        this.errorMessage = 'Algo de errado aconteceu. Tente mais tarde'
                }
            }
        },
    },

    computed: {
        button() {
            if (this.hasReset) {
                return [
                    {
                        text: 'Entrar',
                        type: 'submit',
                    }
                ]
            }
            return [
                {
                    text: `Redefinir ${this.$t('password')}`,
                    type: 'submit',
                }
            ]
        },
        logo() {
            if (this.$store.state.instance.logo == null) {
                return devLogo
            }
            return this.$store.state.instance.logo
        },
    },

}
</script>
